// 检查是否是微信环境
const ua: string = window.navigator.userAgent.toLowerCase();

if (ua.indexOf('micromessenger') == -1) {
    sessionStorage.setItem('isWeixinCent', 'false');
} else {
    sessionStorage.setItem('isWeixinCent', 'true');
}
